import { patchState, signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { withStorage } from '@larscom/ngrx-signals-storage';
import { storagePrefix } from '../storage.const';
import { Auction } from '@/app/lib/types/auction.type';
import { Lot } from '@/app/lib/types/lot.type';
import { BidDetails } from '@/app/lib/types/bid.type';

interface CacheState {
  isLoading: boolean;
  auctions: Auction[];
  lots: Lot[];
  bids: BidDetails[];
  selectedAuction: Auction | null;
  selectedLot: Lot | null;
}

const initialState: CacheState = {
  isLoading: false,
  auctions: [],
  lots: [],
  bids: [],
  selectedAuction: null,
  selectedLot: null,
};

export const CacheStore = signalStore(
  {providedIn: 'root', protectedState: true},
  withState(initialState),
  withProps(() => ({})),
  withMethods(({...store}) => ({
    setAuctions(auctions: Auction[]) {
      patchState(store, {auctions: auctions, lots: [], bids: []});
    },
    setLots(lots: Lot[]) {
      patchState(store, {lots: lots, bids: []});
    },
    setBids(bids: BidDetails[]) {
      patchState(store, {bids: bids});
    },
    setSelectedAuction(auction: Auction | null) {
      if (store.selectedAuction()?.id !== auction?.id) {
        patchState(store, {selectedAuction: auction, lots: [], bids: []});
      }
    },
    setSelectedLot(lot: Lot | null) {
      patchState(store, {selectedLot: lot, bids: []});
    },
    setLoadingState(loadingState: boolean) {
      patchState(store, {isLoading: loadingState});
    },
    resetState() {
      patchState(store, {...initialState});
    },
  })),
  withStorage(`${storagePrefix}cache`, () => sessionStorage),
);
